import { createContext, useContext, useState } from 'react';

const SidebarContext = createContext(null);

export function SidebarProvider({ children }) {
  // Collapsed by DEFAULT (icons + hover tooltips). Only an explicit expand ('0') keeps it open.
  const [collapsed,  setCollapsed]  = useState(() => localStorage.getItem('prvsk_sidebar') !== '0');
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleCollapse = () => {
    setCollapsed(c => {
      const next = !c;
      localStorage.setItem('prvsk_sidebar', next ? '1' : '0');
      return next;
    });
  };

  const toggleMobile = () => setMobileOpen(o => !o);
  const closeMobile  = () => setMobileOpen(false);

  return (
    <SidebarContext.Provider value={{ collapsed, toggleCollapse, mobileOpen, toggleMobile, closeMobile }}>
      {children}
    </SidebarContext.Provider>
  );
}

export const useSidebar = () => useContext(SidebarContext);
